import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchProductStatus, updateProductStatus } from "actions/productStatus";

import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/ProductStatus/Form";

class ProductStatusEdit extends Component {
  componentDidMount() {
    const { match, fetchProductStatus } = this.props;
    const id = match.params.productStatusId;
    fetchProductStatus(id);
  }

  shapedDefaultValuesStructure() {
    const { ...rest } = this.props.productStatus.data;

    return Object.assign(
      {},
      {
        ...rest
      }
    );
  }

  updateProductStatus(id, data) {
    const { toggleNotification, toggleFullPageSpinner, updateProductStatus, history } = this.props;

    toggleFullPageSpinner(true);

    updateProductStatus(id, data)
      .then(() => {
        toggleNotification(true, { message: "Updated ProductStatus Success", infoClassName: "is-success" });
        history.push(`/product-status`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  handleFormSubmit = data => {
    const id = this.props.match.params.productStatusId;

    this.updateProductStatus(id, data);
  };

  render() {
    const { productStatus } = this.props;

    if (productStatus.loading) {
      return "loading";
    }
    const defaultValues = this.shapedDefaultValuesStructure();
    return <Form handleFormSubmit={this.handleFormSubmit} defaultValues={defaultValues} />;
  }
}

const mapStateToProps = ({ productStatus }) => ({
  productStatus
});

export default connect(
  mapStateToProps,
  {
    fetchProductStatus,
    updateProductStatus,
    toggleFullPageSpinner,
    toggleNotification
  }
)(ProductStatusEdit);



// WEBPACK FOOTER //
// ./src/pages/ProductStatus/Edit/index.js